// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ordermaterialslist__filter {
  margin-top: 15px;
  display: flex;
}
.ordermaterialslist__filter-item {
  font-size: 21px;
  font-weight: 400;
  color: #808080;
  padding-right: 10px;
  cursor: pointer;
}
@media (max-width: 490px) {
  .ordermaterialslist__filter-item {
    font-size: 18px;
  }
}
.ordermaterialslist__filter-item.active {
  font-weight: 700;
  color: #212529;
}

.projectmaterial-table {
  table-layout: fixed;
}
@media (max-width: 1024px) {
  .projectmaterial-table {
    table-layout: auto;
  }
}
.projectmaterial__top {
  margin-top: 25px;
  display: flex;
}
.projectmaterial__number {
  font-size: 22px;
  color: rgb(0, 75, 214);
  font-weight: 700;
  padding-right: 10px;
}
@media (max-width: 490px) {
  .projectmaterial__number {
    font-size: 16px;
    font-weight: 500;
    padding-right: 5px;
  }
}
.projectmaterial__project {
  font-size: 22px;
  color: rgb(0, 75, 214);
  font-weight: 700;
  white-space: nowrap;
}
@media (max-width: 490px) {
  .projectmaterial__project {
    font-size: 16px;
    font-weight: 500;
  }
}
.projectmaterial__deadline {
  font-size: 20px;
  color: #212529;
  font-weight: 600;
  white-space: nowrap;
  margin-left: 15px;
}
@media (max-width: 490px) {
  .projectmaterial__deadline {
    font-size: 15px;
    font-weight: 500;
    margin-left: 5px;
  }
}

.materialproject__top {
  margin-top: 25px;
  display: flex;
}
.materialproject__name {
  font-size: 22px;
  color: rgb(0, 75, 214);
  font-weight: 700;
  white-space: nowrap;
}
@media (max-width: 490px) {
  .materialproject__name {
    font-size: 16px;
    font-weight: 500;
  }
}

.button__projectmaterial {
  width: 90px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__projectmaterial.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__projectmaterial {
    width: 50px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__projectmaterial-nocolor {
  width: 90px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__projectmaterial-nocolor.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__projectmaterial-nocolor {
    width: 70px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__projectmaterial-nopayment {
  width: 130px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__projectmaterial-nopayment.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__projectmaterial-nopayment {
    width: 80px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__projectmaterial-add {
  white-space: nowrap;
  width: 90px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-left: 10px;
}
@media (max-width: 490px) {
  .button__projectmaterial-add {
    width: 80px;
    height: 25px;
    font-size: 12px;
    margin-left: 5px;
  }
}
.button__projectmaterial-delete {
  white-space: nowrap;
  width: 80px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-left: 10px;
  margin: 0 auto;
}
@media (max-width: 490px) {
  .button__projectmaterial-delete {
    width: 60px;
    height: 25px;
    font-size: 12px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}

.projectmaterial__search {
  height: 30px;
  width: 120px;
  font-size: 14px;
  outline: none;
}
@media (max-width: 460px) {
  .projectmaterial__search {
    width: 80px;
    height: 20px;
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderMaterialsList/OrderMaterialsList.styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEZ;EACI,gBAAA;EACA,aAAA;AAAR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAAZ;AACY;EANJ;IAOQ,eAAA;EAEd;AACF;AAAY;EACI,gBAAA;EACA,cAAA;AAEhB;;AAMI;EACI,mBAAA;AAHR;AAIQ;EAFJ;IAGQ,kBAAA;EADV;AACF;AAGI;EACI,gBAAA;EACA,aAAA;AADR;AAGI;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AADR;AAEQ;EALJ;IAMQ,eAAA;IACA,gBAAA;IACA,kBAAA;EACV;AACF;AACI;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AAAQ;EALJ;IAMQ,eAAA;IACA,gBAAA;EAGV;AACF;AACI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AACR;AAAQ;EANJ;IAOQ,eAAA;IACA,gBAAA;IACA,gBAAA;EAGV;AACF;;AAGI;EACI,gBAAA;EACA,aAAA;AAAR;AAEI;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AACQ;EALJ;IAMQ,eAAA;IACA,gBAAA;EAEV;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AACI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AACR;AACI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAEN;AACF;AAAI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAER;AADQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAGZ;AADQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAIV;AACF;AADI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAGR;AAFQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAIZ;AAFQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAKV;AACF;AAFI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAIR;AAHQ;EAZJ;IAaQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAMV;AACF;AAHI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAKR;AAJQ;EAbJ;IAcQ,WAAA;IACA,YAAA;IACA,eAAA;EAOV;AACF;;AAHA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAMJ;;AAHA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAMJ;AALI;EALJ;IAMQ,WAAA;IACA,YAAA;IACA,eAAA;EAQN;AACF","sourcesContent":[".ordermaterialslist {\n   \n    &__filter {\n        margin-top: 15px;\n        display: flex;\n\n        &-item {\n            font-size: 21px;\n            font-weight: 400;\n            color: #808080;\n            padding-right: 10px;\n            cursor: pointer;\n            @media(max-width: 490px) {\n                font-size: 18px;\n            }\n           \n            &.active {\n                font-weight: 700;\n                color: #212529;\n            }\n        }\n    }\n}\n\n.projectmaterial {\n\n    &-table {\n        table-layout: fixed;\n        @media(max-width: 1024px) {\n            table-layout: auto;\n        }\n    }\n    &__top {\n        margin-top: 25px;\n        display: flex;\n    }\n    &__number {\n        font-size: 22px;\n        color: rgb(0, 75, 214);\n        font-weight: 700;\n        padding-right: 10px;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            font-weight: 500;\n            padding-right: 5px;\n        }\n    }\n    &__project {\n        font-size: 22px;\n        color: rgb(0, 75, 214);\n        font-weight: 700;\n        white-space: nowrap;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            font-weight: 500;\n        }\n        \n    }\n\n    &__deadline {\n        font-size: 20px;\n        color: #212529;\n        font-weight: 600;\n        white-space: nowrap;\n        margin-left: 15px;\n        @media(max-width: 490px) {\n            font-size: 15px;\n            font-weight: 500;\n            margin-left: 5px;\n        }\n        \n    }\n}\n\n.materialproject {\n    &__top {\n        margin-top: 25px;\n        display: flex;\n    }\n    &__name {\n        font-size: 22px;\n        color: rgb(0, 75, 214);\n        font-weight: 700;\n        white-space: nowrap;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            font-weight: 500;\n        }\n        \n    }\n}\n\n.button__projectmaterial {\n    width: 90px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 50px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n    }\n\n    &-nocolor {\n        width: 90px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 70px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n\n    &-nopayment {\n        width: 130px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 80px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n\n    &-add {\n        white-space: nowrap;\n        width: 90px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-left: 10px;\n        @media(max-width: 490px) {\n            width: 80px;\n            height: 25px;\n            font-size: 12px;\n            margin-left: 5px;\n        }\n    }\n\n    &-delete {\n        white-space: nowrap;\n        width: 80px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-left: 10px;\n        margin: 0 auto;\n        @media(max-width: 490px) {\n            width: 60px;\n            height: 25px;\n            font-size: 12px;\n        }\n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}\n\n.projectmaterial__search {\n    height: 30px;\n    width: 120px;\n    font-size: 14px;\n    outline: none; \n    @media(max-width: 460px) {\n        width: 80px;\n        height: 20px;\n        font-size: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
